// Libraries
import React from "react";
import * as Icones from "../icones";
// Components
import Header from "../Header/Header";
import Page from "../Page";
import "./Video.scss";

export class Video extends Page {
	constructor(props) {
		super(props);
	}

	state = {
		id: null,
		videoInfos: null
	};

	componentDidMount() {
		super.componentDidMount();
		const id = this.props.match.params.id;
		this.setState({ id });
		this.loadVideoInfos(id);
	}

	loadVideoInfos = async id => {
		try {
			const res = await fetch(
				`https://ws.timothee.fr/youtube/api/videos/${id}/info`
			);

			const data = await res.json();

			this.setState({
				videoInfos: data
			});
		} catch (e) {
			console.error(e);
		}
	};

	render() {
		return (
			<>
				<div className="container pt-5 pb-5">
					<div className="text-center pb-3">
						<span
							style={{ backgroundColor: "rgb(124, 180, 215)", fontSize: "1em" }}
							className="text-white pl-3 pr-3 pt-1 pb-1 text-center ft-lato-regular text-uppercase"
						>
							<strong>{"MESSAGE VIDEO"}</strong>
						</span>
					</div>
					<h1
						className="contenu-h1 text-uppercase ft-lato-regular pt-3"
						style={{ fontSize: "1.6em" }}
					>
						<strong>{this.state.videoInfos?.title}</strong>
					</h1>
				</div>

				<div
					className="container-fluid pb-lg-5 no-gutters pt-5 bg-gris"
					style={{ minHeight: "480px" }}
				>
					<div className="container">
						<div className="">
							<div className="pt-md-3 pb-md-3">
								<div style={{ position: "relative" }} className="pb-4">
									<span style={{ position: "absolute" }}>
										<Icones.regarderCircle couleur={this.props.couleur} />
									</span>
									<h4
										style={{ position: "absolute", marginLeft: "45px" }}
										className="d-inline ft-lato-light text-noir"
									>
										REGARDER
									</h4>
								</div>

								<div
									className="text-center coucou"
									style={{ paddingTop: "20px" }}
								>
									<div class="embed-responsive embed-responsive-16by9">
										<iframe
											className="embed-responsive-item"
											src={
												"https://www.youtube.com/embed/" +
												this.state.id +
												"?rel=0"
											}
											frameBorder={0}
											allowFullScreen
											modestbranding={1}
											controls={0}
											rel={0}
											info={0}
											allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}
